module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"thumbnails_title":"Other reviews of this product"}}')
  delete Component.options._Ctor
}
